import {
  getModule,
  Module,
  MutationAction,
  VuexModule,
} from "vuex-module-decorators";
import store from "@/store/regularDeliveryInput";

/**
 * ユーザー属性 Store
 */
@Module({
  dynamic: true,
  store: store,
  name: "regularDeliveryStore",
})
class RegularDeliveryStore extends VuexModule {
  public zip_code = "";
  public pref_name = "";
  public user_id = "";
  public areaDialog = false;
  public deliveryJson = "";
  public regular_delivery_no = "";
  public processFlag = 0;

  /**
   * 値を持っているか
   */
  get hasValue(): boolean {
    return this.zip_code !== "" || this.pref_name !== "" || this.user_id !== "";
  }

  get getZipCode(): string {
    return this.zip_code;
  }

  /**
   * ユーザー属性値を設定
   *
   * @param regularDeliveryInput
   */
  @MutationAction({
    rawError: true,
    mutate: [
      "zip_code",
      "pref_name",
      "user_id",
      "areaDialog",
      "deliveryJson",
      "regular_delivery_no",
      "processFlag",
    ],
  })
  async setupValue(regularDeliveryInput: {
    zip_code: string;
    pref_name: string;
    user_id: string;
    areaDialog: boolean;
    deliveryJson: string;
    regular_delivery_no: string;
    processFlag: number;
  }): Promise<
    RegularDeliveryStore & {
      zip_code: string;
      pref_name: string;
      user_id: string;
      areaDialog: boolean;
      deliveryJson: string;
      regular_delivery_no: string;
      processFlag: number;
    }
  > {
    return {
      ...regularDeliveryInput,
    } as RegularDeliveryStore & {
      zip_code: string;
      pref_name: string;
      user_id: string;
      areaDialog: boolean;
      deliveryJson: string;
      regular_delivery_no: string;
      processFlag: number;
    };
  }
}
export default getModule(RegularDeliveryStore, store);
